import { common, linearColor } from "./const";

// const Aecharts = () => import('@/components/Aecharts');

const Aecharts = a => require(['@/components/Aecharts'], a);

export default {
  name: 'CeBar',
  props: {
    data: {
      type: Array,
      default: () => [
        { id: 1, name: '站点1', value: 18, state: 55, color: '' },
        { id: 2, name: '站点2', value: 85, state: 55, color: '' },
        { id: 3, name: '站点3', value: 67, state: 55, color: '' },
        { id: 4, name: '站点4', value: 32, state: 55, color: '' },
        { id: 5, name: '站点5', value: 21, state: 55, color: '' },
        { id: 6, name: '站点6', value: 45, state: 55, color: '' },
      ]
    },
    title: { type: String, default: () => '标题' },
    type: { type: String, default: () => 'bar' },
    showLegend: { type: Boolean, default: () => false },
    xAxis: { type: Array, default: () => ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'] },
    color: { type: String, default: () => 'red' },
    delay: { type: Number, default: () => 200 },
    backgroundColor: { type: String, default: () => '' },
  },
  data() {
    return {
      option: {},
    }
  },
  watch: {
    data(next, prev) {
      if (JSON.stringify(next) != JSON.stringify(prev)) this.create();
    }
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      const { data, colors } = this;
      const labels = data && data.length > 0 && data.map(a => a['name']);
      const series = data && data.length > 0 && data.map((a, b) => ({
        width: 8,
        data: [a.value],
        type: a.type ? a.type : this.type,
        color: a.color ? a.color : this.color,
        animationDelay: c => c * b * 100,
        barWidth: 12,
        ...a,
      }));
      this.option = {
        ...common(this.$attrs),
        series: [
          {
            name: '温度',
            type: 'bar',
            stack: '总量',
            label: {
              show: false,
            },
            emphasis: {
              focus: 'none',
              label: {
                show: false,
              },
            },
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  // formatter: '{b}\n{c}'
                  formatter: ({ value }) => value.toString().substring(1, value.toString().length) + '℃',
                  color: 'rgba(255, 255, 255, 0.8)',
                  textShadowColor: '#000',
                  textShadowOffsetX: 1,
                  textShadowOffsetY: 1,
                },
                barBorderRadius: [15, 0, 0, 15], //柱形图圆角，初始化效果
                color: linearColor('#53c9d3', '#53b3ff'),
              }
            },
            barWidth: 12,
            data: data.map(a => `-${a.value}`).sort((c, d) => c - d),
          },
          {
            name: '比率',
            type: 'bar',
            stack: '总量',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series',
              label: {
                show: false,
              },
            },
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  // formatter: '{b}\n{c}'
                  // formatter: '{c}',
                  formatter: (a) => a.value + '%',
                  color: 'rgba(255, 255, 255, 0.8)',
                  textShadowColor: '#000',
                  textShadowOffsetX: 1,
                  textShadowOffsetY: 1,
                },
                barBorderRadius: [0, 15, 15, 0], //柱形图圆角，初始化效果
                color: linearColor('#5c2d78', '#da8191'),
              }
            },
            barWidth: 12,
            data: data.map(a => a.state).sort((c, d) => c - d),
          },
        ]
      };
    },
  },
  render() {
    return <Aecharts option={this.option} delay={this.delay} />
  }
}